import { Theme } from '../../../src/types/index.js'

export const theme: Theme = {
  id: 'primary-blueish',
  name: 'Primary blueish',
  palette: {
    primary: '#0069f5',
    accent: '#0094e3',
    neutral: '#d7dce8',
  },
  light1: {
    'action-primary': '#0069f5',
    'action-primary-hovered': '#539dff',
    'action-primary-pressed': '#005cd3',
    'action-primary-subdued': '#f3f9ff',
    'action-primary-subdued-hovered': '#e8f3ff',
    'action-primary-subdued-pressed': '#d3e9ff',
    'action-primary-disabled': '#f3f7ff',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f4f7ff',
    'action-neutral-pressed': '#eff2fa',
    'action-neutral-subdued': '#eff2fa',
    'action-neutral-subdued-hovered': '#e3e6ee',
    'action-neutral-subdued-pressed': '#d1d4dc',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#eef3fe',
    background: '#eff2fa',
    'background-hovered': '#fafbff',
    'background-pressed': '#deeaff',
    'background-selected': '#d1d4dc',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#9aa5ba',
    content: '#181c35',
    'content-subdued': '#32416e',
    'content-muted': '#717277',
    'content-hovered': '#171719',
    'content-pressed': '#525457',
    'content-disabled': '#9ea2ac',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#005bd2',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f4f7ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#181c35',
    'content-on-background-subdued': '#32416e',
    'content-on-background-hovered': '#171719',
    'content-on-background-pressed': '#006ed4',
    'content-on-background-disabled': '#9ea2ac',
    interactive: '#0069f5',
    'interactive-hovered': '#539dff',
    'interactive-pressed': '#0069f5',
    'interactive-disabled': '#f3f7ff',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f3f7ff',
    topbar: '#FFFFFF',
    'topbar-subdued': '#eff2fa',
    'content-on-topbar': '#060607',
    'line-on-topbar': '#9caacd',
    'line-on-topbar-pressed': '#5c6376',
    link: '#0094e3',
    'link-hovered': '#1d4aef',
    'link-pressed': '#1300bb',
    line: '#c3cadb',
    'line-subdued': '#e2e7f3',
    'line-hovered': '#9caacd',
    'line-pressed': '#5c6376',
    'line-selected': '#4b505c',
    'line-disabled': '#e2e7f3',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#0069f5',
    skeleton: '#e2e7f3',
    surface: '#FFFFFF',
    'surface-subdued': '#eff2fa',
    'surface-hovered': '#eff2fa',
    'surface-subdued-hovered': '#e3e6ee',
    'surface-pressed': '#e3e6ee',
    'surface-disabled': '#f3f7ff',
    'surface-selected': '#f3f9ff',
    'surface-selected-hovered': '#e8f3ff',
    'surface-selected-pressed': '#d3e9ff',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#e6eeff',
    'surface-neutral-subdued': '#f4f7ff',
    'surface-inverse': '#171719',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light2: {
    'action-primary': '#0069f5',
    'action-primary-hovered': '#539dff',
    'action-primary-pressed': '#005cd3',
    'action-primary-subdued': '#f4f9ff',
    'action-primary-subdued-hovered': '#e8f3ff',
    'action-primary-subdued-pressed': '#d4e8ff',
    'action-primary-disabled': '#f3f7ff',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f3f7ff',
    'action-neutral-pressed': '#eef3fe',
    'action-neutral-subdued': '#eef3fe',
    'action-neutral-subdued-hovered': '#e2e7f3',
    'action-neutral-subdued-pressed': '#cfd4e0',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#eef3fe',
    background: '#FFFFFF',
    'background-hovered': '#ecf3ff',
    'background-pressed': '#DEEAFF',
    'background-selected': '#e2e7f3',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#9ea2ac',
    content: '#181c35',
    'content-subdued': '#32416e',
    'content-muted': '#717277',
    'content-hovered': '#171719',
    'content-pressed': '#525457',
    'content-disabled': '#9ea2ac',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#00206d',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f3f7ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#181c35',
    'content-on-background-subdued': '#32416e',
    'content-on-background-hovered': '#171719',
    'content-on-background-pressed': '#006ed4',
    'content-on-background-disabled': '#9ea2ac',
    interactive: '#0069f5',
    'interactive-hovered': '#539dff',
    'interactive-pressed': '#0069f5',
    'interactive-disabled': '#f3f7ff',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f3f7ff',
    topbar: '#FFFFFF',
    'topbar-subdued': '#eff2fa',
    'content-on-topbar': '#060607',
    'line-on-topbar': '#9caacd',
    'line-on-topbar-pressed': '#5c6376',
    link: '#0094e3',
    'link-hovered': '#1d4aef',
    'link-pressed': '#1300bb',
    line: '#c3cadb',
    'line-subdued': '#e2e7f3',
    'line-hovered': '#9caacd',
    'line-pressed': '#5c6376',
    'line-selected': '#4b505c',
    'line-disabled': '#e2e7f3',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#0069f5',
    skeleton: '#e2e7f3',
    surface: '#FFFFFF',
    'surface-subdued': '#eff2fa',
    'surface-hovered': '#eff2fa',
    'surface-subdued-hovered': '#e3e6ee',
    'surface-pressed': '#e3e6ee',
    'surface-disabled': '#f3f7ff',
    'surface-selected': '#f3f9ff',
    'surface-selected-hovered': '#e8f3ff',
    'surface-selected-pressed': '#d3e9ff',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#e6eeff',
    'surface-neutral-subdued': '#f4f7ff',
    'surface-inverse': '#171719',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light3: {
    'action-primary': '#0069f5',
    'action-primary-hovered': '#539dff',
    'action-primary-pressed': '#005cd3',
    'action-primary-subdued': '#f4f9ff',
    'action-primary-subdued-hovered': '#e8f3ff',
    'action-primary-subdued-pressed': '#d4e8ff',
    'action-primary-disabled': '#f3f7ff',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#ebf1ff',
    'action-neutral-pressed': '#dee8ff',
    'action-neutral-subdued': '#e2e7f3',
    'action-neutral-subdued-hovered': '#cfd4e0',
    'action-neutral-subdued-pressed': '#cfd4e0',
    'action-neutral-disabled': '#f3f7ff',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#eef3fe',
    background: '#FFFFFF',
    'background-hovered': '#f2f7ff',
    'background-pressed': '#deeaff',
    'background-selected': '#e2e7f3',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#9ea2ac',
    content: '#181c35',
    'content-subdued': '#32416e',
    'content-muted': '#717277',
    'content-hovered': '#171719',
    'content-pressed': '#51545a',
    'content-disabled': '#9ea2ac',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#005bd2',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f3f7ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#181c35',
    'content-on-background-subdued': '#32416e',
    'content-on-background-hovered': '#171719',
    'content-on-background-pressed': '#006ed4',
    'content-on-background-disabled': '#9ea2ac',
    interactive: '#0069f5',
    'interactive-hovered': '#539dff',
    'interactive-pressed': '#0069f5',
    'interactive-disabled': '#f3f7ff',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f3f7ff',
    topbar: '#ebf2ff',
    'topbar-subdued': '#e2e7f3',
    'content-on-topbar': '#060607',
    'line-on-topbar': '#9caacd',
    'line-on-topbar-pressed': '#686d7c',
    link: '#0094e3',
    'link-hovered': '#1d4aef',
    'link-pressed': '#1300bb',
    line: '#c3cadb',
    'line-subdued': '#e2e7f3',
    'line-hovered': '#9caacd',
    'line-pressed': '#696e7c',
    'line-selected': '#4a505c',
    'line-disabled': '#e2e7f3',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#0069f5',
    skeleton: '#e3ebff',
    surface: '#eef3fe',
    'surface-subdued': '#e2e7f3',
    'surface-hovered': '#e2e7f3',
    'surface-subdued-hovered': '#cfd4e0',
    'surface-pressed': '#cfd4e0',
    'surface-disabled': '#f3f7ff',
    'surface-selected': '#f4f9ff',
    'surface-selected-hovered': '#e8f3ff',
    'surface-selected-pressed': '#d4e8ff',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#e2e7f3',
    'surface-neutral-subdued': '#f3f7ff',
    'surface-inverse': '#16171a',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark1: {
    'action-primary': '#0069f5',
    'action-primary-hovered': '#539dff',
    'action-primary-pressed': '#005cd3',
    'action-primary-subdued': '#0c3367',
    'action-primary-subdued-hovered': '#1f51a4',
    'action-primary-subdued-pressed': '#6691d8',
    'action-primary-disabled': '#3f4043',
    'action-neutral': '#2b2e3a',
    'action-neutral-hovered': '#343741',
    'action-neutral-pressed': '#444b59',
    'action-neutral-subdued': '#27282b',
    'action-neutral-subdued-hovered': '#3f4043',
    'action-neutral-subdued-pressed': '#525458',
    'action-neutral-disabled': '#3f4043',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#3f4043',
    background: '#1a1a21',
    'background-hovered': '#252b3b',
    'background-pressed': '#212733',
    'background-selected': '#212530',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#7d8ba2',
    content: '#e9f0ff',
    'content-subdued': '#d0d4dc',
    'content-muted': '#8e97a5',
    'content-hovered': '#e7efff',
    'content-pressed': '#d0d4dc',
    'content-disabled': '#707277',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f4f9fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#c2dbff',
    'content-on-primary': '#ecf4ff',
    'content-on-inverse': '#19191e',
    'content-on-destructive': '#f4f7fe',
    'content-on-interactive': '#f4f7fe',
    'content-on-background': '#ecf2ff',
    'content-on-background-subdued': '#c5ccda',
    'content-on-background-hovered': '#e2ebff',
    'content-on-background-pressed': '#e7efff',
    'content-on-background-disabled': '#707277',
    interactive: '#0069f5',
    'interactive-hovered': '#539dff',
    'interactive-pressed': '#0069f5',
    'interactive-disabled': '#171719',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171719',
    topbar: '#1f1f27',
    'topbar-subdued': '#24242d',
    'content-on-topbar': '#dde4f6',
    'line-on-topbar': '#373a43',
    'line-on-topbar-pressed': '#575f72',
    link: '#2b87ff',
    'link-hovered': '#96c4ff',
    'link-pressed': '#509cff',
    line: '#373a43',
    'line-subdued': '#363943',
    'line-hovered': '#464b57',
    'line-pressed': '#5e6575',
    'line-selected': '#454c5a',
    'line-disabled': '#3f4043',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#041828',
    'line-highlight-subdued': '#041828',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#0069f5',
    skeleton: '#3f4043',
    surface: '#23252d',
    'surface-subdued': '#35373e',
    'surface-hovered': '#1d1f25',
    'surface-subdued-hovered': '#494e57',
    'surface-pressed': '#525458',
    'surface-disabled': '#3f4043',
    'surface-selected': '#1556ab',
    'surface-selected-hovered': '#1f51a4',
    'surface-selected-pressed': '#1f51a4',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#092a42',
    'surface-highlight-subdued': '#154365',
    'surface-highlight-subdued-hovered': '#1f5880',
    'surface-highlight-subdued-pressed': '#1f5880',
    'surface-neutral': '#444a56',
    'surface-neutral-subdued': '#373941',
    'surface-inverse': '#f4f7fe',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark2: {
    'action-primary': '#0069f5',
    'action-primary-hovered': '#539dff',
    'action-primary-pressed': '#005cd3',
    'action-primary-subdued': '#0c3367',
    'action-primary-subdued-hovered': '#1f51a4',
    'action-primary-subdued-pressed': '#6691d8',
    'action-primary-disabled': '#3f4043',
    'action-neutral': '#15151a',
    'action-neutral-hovered': '#23252a',
    'action-neutral-pressed': '#35373e',
    'action-neutral-subdued': '#24272f',
    'action-neutral-subdued-hovered': '#3f4043',
    'action-neutral-subdued-pressed': '#3f4043',
    'action-neutral-disabled': '#27282b',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#3f4043',
    background: '#23252d',
    'background-hovered': '#2b2e36',
    'background-pressed': '#1a1a21',
    'background-selected': '#2b2e36',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#8f9bad',
    content: '#e9f0ff',
    'content-subdued': '#d0d4dc',
    'content-muted': '#9ea2a8',
    'content-hovered': '#e7efff',
    'content-pressed': '#d0d4dc',
    'content-disabled': '#707277',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f4f9fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#c2dbff',
    'content-on-primary': '#ecf4ff',
    'content-on-inverse': '#171719',
    'content-on-destructive': '#f4f7fe',
    'content-on-interactive': '#f4f7fe',
    'content-on-background': '#ecf2ff',
    'content-on-background-subdued': '#c5ccda',
    'content-on-background-hovered': '#e2ebff',
    'content-on-background-pressed': '#e7efff',
    'content-on-background-disabled': '#707277',
    interactive: '#0069f5',
    'interactive-hovered': '#539dff',
    'interactive-pressed': '#0069f5',
    'interactive-disabled': '#171719',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171719',
    topbar: '#24242d',
    'topbar-subdued': '#1f1f27',
    'content-on-topbar': '#dde4f6',
    'line-on-topbar': '#34373e',
    'line-on-topbar-pressed': '#616673',
    link: '#2b87ff',
    'link-hovered': '#64a8de',
    'link-pressed': '#96c4ff',
    line: '#373941',
    'line-subdued': '#353840',
    'line-hovered': '#51565f',
    'line-pressed': '#616775',
    'line-selected': '#494e57',
    'line-disabled': '#3f4043',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#041828',
    'line-highlight-subdued': '#041828',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#0069f5',
    skeleton: '#3f4043',
    surface: '#1a1b21',
    'surface-subdued': '#202227',
    'surface-hovered': '#2e2f38',
    'surface-subdued-hovered': '#292b32',
    'surface-pressed': '#3f4043',
    'surface-disabled': '#27282b',
    'surface-selected': '#123d83',
    'surface-selected-hovered': '#1f51a4',
    'surface-selected-pressed': '#163d7c',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#092a42',
    'surface-highlight-subdued': '#154365',
    'surface-highlight-subdued-hovered': '#1f5880',
    'surface-highlight-subdued-pressed': '#1f5880',
    'surface-neutral': '#525458',
    'surface-neutral-subdued': '#3f4043',
    'surface-inverse': '#f4f7fe',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
}
